<template>
  <div class="action-bar flex items-center gap-24" :class="wrapperClass">
    <div
      v-for="item in visibleItems"
      :key="item.key"
      v-permission="getPermissionForAction(item.key)"
      class="action-item flex items-center gap-4 cursor-pointer color-label font-medium text-14 filter-button"
      :class="[{ disabled: isDisabled(item.key) }, item.className]"
      @click="handleClick(item)"
      @mouseenter="hoverKey = item.key"
      @mouseleave="hoverKey = ''"
    >
      <img
        v-if="getImg(item.key)"
        class="icon w-14 h-14 "
        :src="getImg(item.key)"
        :alt="item.label"
      />
      <span class="label text-14 font-medium color-label" :class="{ primary: primaryKey === item.key }">{{ item.label }}</span>
    </div>
  </div>
  
</template>
<script>
export default {
  name: 'ActionBar',
  props: {
    // 显示哪些按钮：['filter','view','delete','add','edit','download','import']
    actions: {
      type: Array,
      default: () => ['delete', 'add', 'edit', 'download', 'import']
    },
    // 禁用映射：{ delete: true }
    disabledMap: {
      type: Object,
      default: () => ({})
    },
    // 可见性映射：{ delete: false }
    visibleMap: {
      type: Object,
      default: () => ({})
    },
    // 图标映射：{ filter: require('@/assets/filter.png') }
    iconMap: {
      type: Object,
      default: () => ({})
    },
    // 选中项，支持 v-model:activeKeys
    activeKeys: {
      type: Array,
      default: () => []
    },
    // 点击是否在组件内部切换选中状态
    toggleOnClick: {
      type: Boolean,
      default: true
    },
    // 主色高亮的 key（例如筛选）
    primaryKey: {
      type: String,
      default: 'filter'
    },
    // 外层自定义 class
    wrapperClass: {
      type: String,
      default: ''
    },
    // 权限映射：{ add: 'project:add', delete: 'project:del' }
    permissionMap: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      hoverKey: '',
      defaultImageMap: {
        filter: {
          normal: require('@/assets/filter.png'),
        },
        add: {
          normal: require('@/assets/add.png'),
        },
        delete: {
          normal: require('@/assets/del.png'),
        },
        download: {
          normal: require('@/assets/download.png'),
        },
        import: {
          normal: require('@/assets/export.png'),
        },
        export: {
          normal: require('@/assets/export.png'),
        }
      }
    }
  },
  computed: {
    baseItems() {
      // 默认文案及回退图标
      return [
        { key: 'filter', label: '筛选', },
        { key: 'view', label: '视图', },
        { key: 'delete', label: '删除', },
        { key: 'add', label: '新增',},
        { key: 'edit', label: '编辑', },
        { key: 'download', label: '下载', },
        { key: 'import', label: '导入', },
        { key: 'export', label: '导出', },
      ]
    },
    visibleItems() {
      const allowed = new Set(this.actions)
      return this.baseItems
        .filter(it => allowed.has(it.key))
        .filter(it => this.visibleMap[it.key] !== false)
    },
  },
  methods: {
    getImg(key) {
      // 使用图片，优先外部 iconMap，支持 normal/select 两种
      const record = this.iconMap[key] || this.defaultImageMap[key] || {}
      return (record.normal || '')
    },
    isActive(key) {
      return (this.activeKeys || []).includes(key)
    },
    isDisabled(key) {
      return !!this.disabledMap[key]
    },
    // 获取按钮对应的权限
    getPermissionForAction(actionKey) {
      return this.permissionMap[actionKey] || null
    },
    handleClick(item) {
      if (this.isDisabled(item.key)) return
      // 派发统一事件与专用事件
      this.$emit('action', item.key)
      this.$emit(item.key)
      if (this.toggleOnClick) {
        const next = new Set(this.activeKeys)
        if (next.has(item.key)) next.delete(item.key)
        else next.add(item.key)
        this.$emit('update:activeKeys', Array.from(next))
      }
    }
  }
}
</script>

<style scoped>
.action-item:hover span{ color: rgba(42, 117, 247, 1) !important; }
.action-item.disabled { opacity: .45; cursor: not-allowed; }
</style>


